module.exports = __webpack_public_path__ + "static/Vishal-2dfb58d65426a4a4418d366d5d2c7984.jpg";